module.exports = __webpack_public_path__ + "220f9261398871a827c1303a968426f0.svg";